import React, { Component } from 'react'

export default class CheckBox extends Component {


    render() {
        const{label, name, type, id, checked, value,disable} = this.props;
        return (
            <div className="checkbox_field_row">
                <div className="checkBox">
                    <input 
                        type={type} 
                        id={id} 
                        name={name} 
                        checked={checked}
                        disabled={disable}
                        value={value}
                        onChange={(e) => this.props.onChange(e)} />
                    <label for={id}>{label}</label>
                </div>
            </div>
        )
    }
}
